/* global window */

var graphlib;

if (typeof require === "function") {
  try {
    graphlib = require("graphlib");
  }
  catch (e) {
    // continue regardless of error
  }
}

if (!graphlib) {
  graphlib = window.graphlib;
}

module.exports = graphlib;



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/lib/graphlib.js
// module id = 1662
// module chunks = 0